import styles from './FormInput.module.css';

// `type="password"` must reach the DOM as a real password input — that is the only
// signal Chrome and Firefox use to offer saving and filling a credential. Callers
// pass `autoComplete` ("username" / "current-password" / "new-password") so the
// hint survives the show-password toggle flipping `type` to "text".
function FormInput({
  label,
  id,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  className = '',
  ...rest
}) {
  return (
    <div className={`${styles.wrapper} mb-3`}>
      <label htmlFor={id} className={`${styles.label} mb-1 d-block`}>{label}</label>
      <input
        id={id}
        name={name ?? id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`${styles.input} form-control ${error ? styles.inputError : ''} ${className}`}
        {...rest}
      />
      {error && <p className={styles.errorMsg}>{error}</p>}
    </div>
  );
}

export default FormInput;
